<section id="section-report" class="container-fluid mt-1">
  <div class="row" *ngIf="maintenanceRoutinePrintContract">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}" class="head col-12 col-lg-12">
                  <!--Nombre Compañía -->
                  <p id="nombre-compania-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceRoutinePrintContract.companyName}}</p>

                  <!--Nombre rutina -->
                  <p id="nombre-rutina-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    Informe de Rutina Mantenimiento
                  </p>

                  <!--Nombre equipo -->
                  <label id="t-nombre-equipo-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-nombre-equipo' |
                    formatLabelPipe : elementsLabel}}</label>

                  <p id="nombre-equipo-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceRoutinePrintContract.articleCodeName}}
                  </p>

                  <!-- Fecha -->
                  <label id="t-fecha-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{dateNow | date: 'dd/MM/yyyy'}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <!--------------------------------------------- Tabla Estrategias -------------------------------------->
                <label id="titulo-estrategia-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  (click)="onClick()">{{'titulo-estrategia' |
                  formatLabelPipe : elementsLabel}}</label>
                <div id="container-strategy" class="mb-3">
                  <app-custom-table-print id="estrategia-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                    [columns]="columnsStrategies" [data]="maintenanceRoutinePrintContract.maintenanceStrategies"
                    [idMap]="idMapStrategies" [documentId]="maintenanceRoutinePrintContract.maintenanceRoutineId"
                    [footerVisible]="false" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                    (newIndexColumns)="onColumnStrategiesReorder($event)"></app-custom-table-print>
                </div>

                <!--------------------------------------------- Tabla Actividades -------------------------------------->
                <p-table [value]="maintenanceRoutinePrintContract.maintenanceActivities" [columns]="columnsActivities"
                  [reorderableColumns]="editFormat" (onColReorder)="onColumnActivitiesReorder()"
                  rowGroupMode="subheader" groupRowsBy="groupKey" sortField="groupKey" sortMode="single"
                  styleClass="p-datatable-sm mb-3" showGridlines>

                  <ng-template #header pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" pReorderableColumn
              [id]="'th-' + idMapActivities[col.field].id + '-' + maintenanceRoutinePrintContract.maintenanceRoutineId"
              (click)="clickTable($event)" [class]=" idMapActivities[col.field].id">
              {{ col.header }}
            </th>
          </tr>
          </ng-template>
          <ng-template #groupheader pTemplate="groupheader" let-rowData let-rowIndex="rowIndex">
            <tr *ngIf="isFirstInGroup(rowIndex, 'componentId')" pRowGroupHeader>
              <td [attr.colspan]="columnsActivities.length" class="">
                <p id="foot-group-componente-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}"
                  (click)="onClick()" class="group-componente" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">COMPONENTE: {{ rowData.componentCode }} - {{
                  rowData.componentName}}</p>
              </td>
            </tr>
            <tr *ngIf="isFirstInGroup(rowIndex, 'groupKey')" pRowGroupHeader>
              <td [attr.colspan]="columnsActivities.length" class="">
                <p id="foot-group-elemento-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}" (click)="onClick()"
                  class="group-elemento ps-2" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">ELEMENTO: {{
                  rowData.elementCode }} - {{
                  rowData.elementName}}</p>
              </td>
            </tr>
          </ng-template>
          <ng-template #body pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td *ngFor="let col of columns" [id]="'td-' + idMapActivities[col.field].id + '-' + rowData.id"
                (click)="clickTable($event)">
                {{rowData[col.field] | dynamicFormatPipe: idMapActivities[col.field].type}}
              </td>
            </tr>
          </ng-template>
          </p-table>
          <!--------------------------------------------- Tabla Insumos -------------------------------------->
          <label id="titulo-insumos-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}" (click)="onClick()"
            (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
            [hidden]="maintenanceRoutinePrintContract.maintenanceRoutineSupplies.length === 0">{{'titulo-insumos' |
            formatLabelPipe : elementsLabel}}</label>
          <div id="container-supplies">

            <app-custom-table-print [hidden]="maintenanceRoutinePrintContract.maintenanceRoutineSupplies.length === 0"
              id="insumos-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}" [columns]="columnsSupplies"
              [data]="maintenanceRoutinePrintContract.maintenanceRoutineSupplies" [idMap]="idMapSupplies"
              [documentId]="maintenanceRoutinePrintContract.maintenanceRoutineId" [footerVisible]="false"
              [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
              (newIndexColumns)="onColumnSuppliesReorder($event)"></app-custom-table-print>
          </div>
    </div>
    <div id="foot-{{maintenanceRoutinePrintContract.maintenanceRoutineId}}" class="foot">
    </div>
    </td>
    </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="1">
          <div class="row">
            <div class="col-12 d-flex gap-2">
              <!-- Versión CW-->
              <p class="label-footer-page">{{version}}</p>

              <!-- Fecha Impresión-->
              <label class="label-footer-page">Fecha</label>
              <p class="footer-page">{{dateNow | date: 'dd/MM/yyyy'}}</p>

              <!-- Hora Impresión-->
              <label class="label-footer-page">Hora:</label>
              <p class="footer-page">{{dateNow | date: 'hh:mm:ss a'}}</p>

              <!-- Usuario Impresión-->
              <label class="label-footer-page">Usuario:</label>
              <p class="footer-page">{{userAuthenticated}}</p>
            </div>
          </div>
          <p id="message"></p>
        </td>
      </tr>
    </tfoot>
    </table>
  </div>
  </div>
</section>